import { Component, OnInit, Input } from '@angular/core';
import { AlertMessage} from './alert-message';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  @Input() alertMessage: AlertMessage;

  constructor() {

  }

  ngOnInit() {
  }

  ago() {
    // let diff = Date.now() - this.alertMessage.time;
    return '1 hour ago';
  }
  isRecent() {
    return false;
  }
  isLate() {
    return true;
  }
  isReallyLate() {
    return false;
  }
}
